exports = module.exports = require("../../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n.container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-width: 300px;\n  width: 48%;\n  margin: 8px; }\n.mat-table {\n  overflow: auto;\n  max-height: 500px; }\n.title {\n  color: white;\n  background-color: #1d838e;\n  padding: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/pro-reference/proReference.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/pro-reference/proReference.component.scss
// module chunks = main